import React from 'react'
import PortfolioMenu from './PortfolioMenu'

const PortfolioMenuIntroDesktop = () => {
  return (
    <div className="portfolio-menu-intro-desktop">
      <PortfolioMenu />
    </div>
  )
}

export default PortfolioMenuIntroDesktop  


// WEBPACK FOOTER //
// ./src/PortfolioMenuIntroDesktop.js